import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

type PathToComponentInfo = {
  [key: string]: {
    componentName: string;
    viewCategory: string;
  };
};

const useCurrentComponentLocation = () => {
  const location = useLocation();
  const [locationInfo, setLocationInfo] = useState<{
    componentName: string;
    viewCategory: string;
  }>({
    componentName: "",
    viewCategory: "",
  });

  useEffect(() => {
    const pathToComponentInfo: PathToComponentInfo = {
      '/': { componentName: 'DashBoard', viewCategory: 'Home' },
      '/policies': { componentName: 'Policies', viewCategory: 'Apps' },
      '/add-policy': { componentName: 'Policy Form', viewCategory: 'Apps' },
      '/upload-policy': { componentName: 'Policy Upload', viewCategory: 'Apps' },
      '/import-policy': { componentName: 'Policy Import', viewCategory: 'Apps' },
      '/file-repository': { componentName: 'File Repository', viewCategory: 'Apps' },
      '/fileRepositoryForm': { componentName: 'File Repository Form', viewCategory: 'Apps' },
      '/view-file-repository-list': { componentName: 'View FileRepository List', viewCategory: 'Apps' },
      '/incident-response-plan-form': { componentName: 'Incident Response Plan Form', viewCategory: 'Apps' },
      '/incident-response-plan': { componentName: 'Incident Response Plan', viewCategory: 'Apps' },
      '/risk-assessment': { componentName: 'Risk Assessment', viewCategory: 'Apps' },
      '/cs-risk-assessment-form': { componentName: 'Add New Risk', viewCategory: 'Apps' },
      '/supply-chain-risk-assessment-form': { componentName: 'Add New Risk', viewCategory: 'Apps' },
      '/risk-assessment-control': { componentName: 'Control', viewCategory: 'Apps' },
      '/risk-management': { componentName: 'Risk Management', viewCategory: 'Apps' },
      '/risk-management-form': { componentName: 'Risk Management Form', viewCategory: 'Apps' },
      '/incident-response-playbook': { componentName: 'Incident Response Playbook', viewCategory: 'Apps' },
      '/incident-response-playbook-form': { componentName: 'Incident Response Playbook Form', viewCategory: 'Apps' },
      '/incident-response-test': { componentName: 'Incident Response Tests', viewCategory: 'Apps' },
      '/risk-management-appendix': { componentName: 'Risk Management Appendix', viewCategory: 'Apps' },
      '/risk-management-appendix-form': { componentName: 'Risk Management Appendix Form', viewCategory: 'Apps' },
      '/company-profile': { componentName: 'Company Profile', viewCategory: 'User' },
    };

    const { componentName = "UnknownComponent", viewCategory = "Unknown" } =
      pathToComponentInfo[location.pathname as keyof typeof pathToComponentInfo] || {};

    setLocationInfo({
      componentName,
      viewCategory,
    });
  }, [location]);

  return locationInfo;
};

export default useCurrentComponentLocation;
